import { http } from '../core/services/http'
import { IBlogCategory } from '../core/interfaces'
import { SimpleSearchPaginationParams, Pagination } from '../core/services/utils'
import { UUID } from 'node:crypto'

export const getAllBlogCategories = (params?: SimpleSearchPaginationParams) => {
    return http.get<Pagination<IBlogCategory>>('/api/dashboard/blog-categories', { params })
}

export const getAllBlogCategoriesFlat = () => {
    return http.get<IBlogCategory[]>('/api/dashboard/blog-categories/all')
}

export const createBlogCategory = (data: IBlogCategory) => {
    return http.post<IBlogCategory>('/api/dashboard/blog-categories', data)
}

export const updateBlogCategory = (id: UUID, data: IBlogCategory) => {
    return http.put<IBlogCategory>(`/api/dashboard/blog-categories/${id}`, data)
}

export const deleteBlogCategory = (id: UUID) => {
    return http.delete(`/api/dashboard/blog-categories/${id}`)
}

export const toggleBlogCategoryVisibility = (id: UUID) => {
    return http.post<IBlogCategory>(`/api/dashboard/blog-categories/${id}/toggle-visibility`)
}
